import { Route } from "components/utils";
import { Dashboard as ExternalManufacturerDashboard } from "pages/externalManufacturerPanel/dashboard/Dashboard";
import { NotFound } from "pages/notFound";
import { RouteComponentProps, Switch } from "react-router-dom";

export const Dashboard = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        component={ExternalManufacturerDashboard}
        exact={true}
        path={`${match.path}`}
        title="Milo - panel pracownika"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
